import { API_URL } from '@src/configs';
import api from './api';

const getLanguages = async ({ voiceOwnership }) => {
  const response = await api({
    method: 'GET',
    url: `${API_URL}/api/v3/languages`,
    params: {
      voiceOwnership,
    },
  });

  return response;
};

export { getLanguages };
